import React from "react";
import PropTypes from "prop-types";

import ShowImagesPlanInitial from "./atoms/ShowImagesPlanInitial/ShowImagesPlanInitial";
import ShowImagesPlanLight from "./atoms/ShowImagesPlanLight/ShowImagesPlanLight";
import ShowImagesPlanMix from "./atoms/ShowImagesPlanMix/ShowImagesPlanMix";
import ShowImagesPlanTop from "./atoms/ShowImagesPlanTop/ShowImagesPlanTop";

import { isObjectEmpty, installmentFormatter } from "../../../../lib/utils";
import { tvCategories } from "../../../../enum/tvCategories";

import tvImg from "../../../../images/tv-filled-black.svg";
import {
  ProductTVValueHeaderElement,
  ProductTVValueTVImgElement,
  ProductTVValueTVNameElement,
  ProductTVValueTVTextElement,
  ProductTVValueChannelsTextElement,
  ProductTVValueChannelsImgElement,
  ProductTVValuePriceElement,
  ProductTVValueValidateElement,
} from "./ProductTVValue.styles";

import CardBox from "../../../shared/CardBox/CardBox";
import Button from "../../../shared/Button/Button";

const ProductTVValue = ({ productTVValue, onClick }) => {
  if (isObjectEmpty(productTVValue)) {
    return <CardBox>{[]}</CardBox>;
  }

  const renderImgPlanContent = () => {
    let content;

    if (productTVValue.category === tvCategories.INICIAL) {
      content = <ShowImagesPlanInitial />;
    } else if (productTVValue.category === tvCategories.LIGHT_DIGITAL) {
      content = <ShowImagesPlanLight />;
    } else if (productTVValue.category === tvCategories.MIX_DIGITAL) {
      content = <ShowImagesPlanMix />;
    } else if (productTVValue.category === tvCategories.TOP_DIGITAL) {
      content = <ShowImagesPlanTop />;
    }

    return content;
  };

  const renderValidityPlan = () => {
    let validity;

    if (productTVValue.category === tvCategories.INICIAL) {
      validity = `Validade 30,60 ou 90 dias`;
    } else {
      validity = `Validade ${productTVValue.plans[0].validity} dias`;
    }

    return validity;
  };

  return (
    <CardBox>
      <ProductTVValueHeaderElement>
        <ProductTVValueTVImgElement src={tvImg} alt="" />
        <ProductTVValueTVNameElement>
          {productTVValue.category.replace("_", " ")}
        </ProductTVValueTVNameElement>
      </ProductTVValueHeaderElement>
      <ProductTVValueTVTextElement>
        + de{" "}
        <ProductTVValueChannelsTextElement>
          {productTVValue.channelsCount}
        </ProductTVValueChannelsTextElement>{" "}
        canais
      </ProductTVValueTVTextElement>
      <ProductTVValueChannelsImgElement>{renderImgPlanContent()}</ProductTVValueChannelsImgElement>
      <ProductTVValuePriceElement>
        {productTVValue && installmentFormatter(productTVValue.plans[0].price)}
      </ProductTVValuePriceElement>
      <Button
        onClick={() => {
          onClick(productTVValue);
        }}
        textColor="black"
        backgroundColor="#ffbc4a"
        fontWeight="bold"
        text="Eu quero"
      />
      {productTVValue && productTVValue.plans[0].validity && (
        <ProductTVValueValidateElement>{renderValidityPlan()}</ProductTVValueValidateElement>
      )}
    </CardBox>
  );
};

ProductTVValue.propTypes = {
  productTVValue: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

ProductTVValue.defaultProps = {
  productTVValue: {},
};

export default ProductTVValue;
